import './style.css';

import React, { MouseEventHandler, useCallback } from 'react';
import { Tooltip, withStyles } from '@material-ui/core';

import { GizmoData } from '../../../SceneLoader';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#333',
    fontSize: theme.typography.pxToRem(14),
  },
}))(Tooltip);

interface GizmoElementProps {
  data: GizmoData;
  onClick?: () => void;
}

export const GizmoElement: React.FC<GizmoElementProps> = ({
  onClick,
  ...props
}) => {
  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      onClick?.();
      e.currentTarget.blur();
    },
    [onClick]
  );

  return (
    <HtmlTooltip title={props.data.title} placement="top" arrow>
      <div
        className="gizmo-outer-container"
        style={{
          width: props.data.size ?? '50px',
          height: props.data.size ?? '50px',
        }}
      >
        <button className="gizmo-container" onClick={handleClick} tabIndex={-1}>
          {props.data.icon && (
            <img
              src={`assets/icons/${props.data.icon}.svg`}
              alt={'Missing Icon'}
              className="gizmo-icon"
            />
          )}
        </button>
      </div>
    </HtmlTooltip>
  );
};
